module.exports = __webpack_public_path__ + "static/media/S13_W.61ce9b70.png";